<template>
  <router-view v-if="!isBlocked" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['userInfo']),
    hasUserInfo() {
      return Boolean(this.userInfo.companyName);
    },
    isMyBizPage() {
      return /^\/mybiz\//.test(this.$route.path);
    },
    isBlocked() {
      // 유저정보가 없는 상태에서는 마이비즈 페이지 진입을 차단
      if (this.isMyBizPage && !this.hasUserInfo) return true;
      return false;
    },
  },
};
</script>

<style></style>
